import { FormSchema } from "@/pages/carts/show.vue"
import { useI18n } from "vue-i18n"


export function usePagSeguroEncryption(form: FormSchema) {
  const { t } = useI18n()

  function encryptCardData() {
    if (!window.PagSeguro || typeof window.PagSeguro.encryptCard !== 'function') {
      console.error('A biblioteca PagSeguro não foi carregada corretamente.')
      return
    }

    const cardNumber = form.card_number.replace(/\s+/g, '')
    const expParts = form.card_exp.split('/')

    const card = window.PagSeguro.encryptCard({
      publicKey: import.meta.env.VITE_PAGBANK_PUBLIC_KEY,
      holder: form.card_holder,
      number: cardNumber,
      securityCode: form.card_cvv,
      expMonth: expParts[0],
      expYear: expParts[1],
    })


    if (card.hasErrors) {
      handleCardErrors(card.errors)
    } else {
      form.encrypted_card = card.encryptedCard
    }
  }

  function handleCardErrors(errors: any[]) {
    const errorMapping = {
      INVALID_NUMBER: () => form.setError('card_number', t('credit_card_errors.INVALID_NUMBER')),
      INVALID_EXPIRATION_MONTH: () => form.setError('card_exp', t('credit_card_errors.INVALID_EXPIRATION_MONTH')),
      INVALID_EXPIRATION_YEAR: () => form.setError('card_exp', t('credit_card_errors.INVALID_EXPIRATION_YEAR')),
      INVALID_HOLDER: () => form.setError('card_holder', t('credit_card_errors.INVALID_HOLDER')),
      INVALID_SECURITY_CODE: () => form.setError('card_cvv', t('credit_card_errors.INVALID_SECURITY_CODE')),
    }

    errors.forEach((error) => {
      const errorHandler = errorMapping[error.code as keyof typeof errorMapping]
      if (errorHandler) errorHandler()
    })
  }

  return {
    encryptCardData,
  }
}
